import React, { useState } from 'react'
import { connect } from 'react-redux'
import { deleteAllNotifications } from '../../../../../action/notification-actions'
import './index.scss'
import NotificationItem from './notification-item'

const Notifications = props => {
  const { hidePopout, notifications, deleteAllNotifications } = props,
    makeEntries = () => {
      if (notifications.length === 0) {
        return (
          <p style={{ fontSize: '16px', color: 'white' }}>You have no new notifications or alerts.</p>
        )
      }
      return notifications.sort((a, b) => b.id - a.id).map(notification => {
        return <NotificationItem entry={notification} key={notification.id} />
      })
    }

  return (
    <div style={{ width: '100%' }}>
      <div className='popout-close' onClick={hidePopout}></div>
      <div className='popout-header'>Notifications</div>
      {notifications.length > 0 ?
        (<div style={{ width: '100%', marginBottom: '10px' }}>
          <p style={{
            width: '75px',
            position: 'relative',
            left: '100%',
            transform: 'translateX(-100%)',
            cursor: 'pointer'
          }}
            onClick={() => { deleteAllNotifications() }}>Delete All</p>
        </div>)
        : null
      }
      <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
        {makeEntries()}
      </div>
    </div >
  )
}

const mapStateToProps = state => ({
  notifications: state.notifications
})

const mapDispatchToProps = dispatch => ({
  deleteAllNotifications: () => dispatch(deleteAllNotifications())
})

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)